import type { Backend } from '@freelancer/datastore/core';
import {
  OrderByDirection,
  getQueryParamValue,
} from '@freelancer/datastore/core';
import type { BusinessBuilderTemplateCollection } from './business-builder-template.types';

export function businessBuilderTemplateBackend(): Backend<BusinessBuilderTemplateCollection> {
  return {
    defaultOrder: {
      direction: OrderByDirection.DESC,
      field: 'blueprintUuid',
    },
    fetch: (authUid, ids, query) => {
      const blueprintUuids = getQueryParamValue(query, 'blueprintUuid');
      return {
        endpoint: 'business-builder/template.php',
        method: 'GET',
        isGaf: true,
        params: {
          blueprintUuid: blueprintUuids[0],
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
